import * as React from 'react';
import s from './Text.module.scss';

interface Props {
  span?: boolean; // True if text should be shown in inline-style, otherwise false.
  p?: boolean; // The text style p
  h1?: boolean;
  h2?: boolean;
  h3?: boolean;
  h4?: boolean;
  h5?: boolean;
  h6?: boolean;
  ingressLarge?: boolean;
  ingressMedium?: boolean;
  ingress?: boolean;
  pMedium?: boolean;
  pSmall?: boolean;
  caption?: boolean;
  captionSmall?: boolean;
  light?: boolean;
  teal?: boolean;
  byline?: boolean;
  label?: boolean;
  preLine?: boolean;
  center?: boolean;
  left?: boolean;
  bold?: boolean;
  italic?: boolean;
  children: any;
}

const Text = ({
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  ingressLarge,
  ingressMedium,
  ingress,
  pMedium,
  pSmall,
  light,
  teal,
  caption,
  captionSmall,
  byline,
  children,
  preLine,
  center,
  left,
  bold,
  italic,
  label,
  span,
}: Props) => {
  let Style;
  Style = p ? 'pBread' : Style;
  Style = h1 ? 'h1' : Style;
  Style = h2 ? 'h2' : Style;
  Style = h3 ? 'h3' : Style;
  Style = h4 ? 'h4' : Style;
  Style = h5 ? 'h5' : Style;
  Style = h6 ? 'h6' : Style;
  Style = ingressLarge ? 'ingressLarge' : Style;
  Style = ingressMedium ? 'ingressMedium' : Style;
  Style = ingress ? 'ingress' : Style;
  Style = pMedium ? 'pMedium' : Style;
  Style = pSmall ? 'pSmall' : Style;
  Style = caption ? 'caption' : Style;
  Style = label ? 'label' : Style;
  Style = captionSmall ? 'captionSmall' : Style;
  Style = byline ? 'byline' : Style;

  if (light && teal) {
    throw new Error('Cannot set both light and teal');
  }

  const Element = span ? 'span' : 'p';

  return (
    <Element
      className={[
        s[Style],
        light ? s.light : s.dark,
        teal ? s.teal : '',
        preLine ? s.preLine : '',
        center ? s.center : '',
        left ? s.left : '',
        bold ? s.bold : '',
        italic ? s.italic : '',
      ].join(' ')}
    >
      {children}
    </Element>
  );
};

export default Text;
